"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ServiceRequest_1 = require("../ServiceRequest");
function shouldSignInToSkypeOperation(options) {
    return ServiceRequest_1.makeServiceRequest("ShouldSignInToSkype", {}, options);
}
exports.default = shouldSignInToSkypeOperation;
